import { AuditLiveMention, DateTimeStr, Station, TimeRange } from '@mi-front/core';
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../api';
import { isAuditEnabled } from '../helpers';

export function useAuditLiveMentionsMatches(station: Station, range: TimeRange<DateTimeStr>) {
  const fetch = async () => {
    if (!isAuditEnabled(station)) {
      return [];
    }

    const { results } = await apiClient.audit.fetchLiveMentionsMatches({
      stationId: station.id,
      filter: {
        from: range.from,
        to: range.to,
      },
    });

    return results as AuditLiveMention[];
  };

  return useQuery({
    queryKey: [
      'audit-live-mentions-matches',
      {
        station: station.id,
        range,
      },
    ],

    queryFn: fetch,
  });
}
